import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Sparkles, Mail, Youtube, Instagram } from "lucide-react";

export const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer data-testid="footer" className="py-16" style={{ backgroundColor: 'var(--th-footer-bg)', color: 'var(--th-footer-text)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-8">
          <div className="text-center md:text-left">
            <div className="flex items-center gap-3 justify-center md:justify-start mb-4">
              <div className="w-12 h-12 rounded-xl flex items-center justify-center" style={{ backgroundColor: 'var(--th-primary)' }}><Sparkles className="w-7 h-7" style={{ color: '#1E293B' }} /></div>
              <span className="font-heading font-bold text-xl">Teacher Happy</span>
            </div>
            <p className="text-sm opacity-80 max-w-xs mx-auto md:mx-0">{t('footer.tagline')}</p>
            <p className="text-xs opacity-60 mt-4">{t('footer.timezones')}</p>
          </div>

          {/* Follow Us section - Hidden for now (will add social links later)
          <div className="text-center">
            <h4 className="font-heading font-bold text-lg mb-4">{t('footer.followUs')}</h4>
            <div className="flex items-center justify-center gap-4">
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full flex items-center justify-center transition-all hover:scale-110" style={{ backgroundColor: 'rgba(255,255,255,0.1)' }} data-testid="social-youtube">
                <Youtube className="w-6 h-6" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full flex items-center justify-center transition-all hover:scale-110" style={{ backgroundColor: 'rgba(255,255,255,0.1)' }} data-testid="social-instagram">
                <Instagram className="w-6 h-6" />
              </a>
            </div>
          </div>
          */}

          <div className="text-center md:text-right">
            <h4 className="font-heading font-bold text-lg mb-4">{t('footer.contactUs')}</h4>
            <div className="flex items-center gap-2 justify-center md:justify-end mb-4">
              <Mail className="w-5 h-5 opacity-80" />
              <a href="mailto:oscar@teacherhappy.com" className="hover:opacity-100 transition-opacity opacity-80" data-testid="footer-email">oscar@teacherhappy.com</a>
            </div>
            <div className="flex flex-col sm:flex-row gap-2 justify-center md:justify-end mb-4">
              <Link to="/privacy" className="text-sm opacity-70 hover:opacity-100 transition-opacity" data-testid="privacy-link">{t('footer.privacyPolicy')}</Link>
              <span className="hidden sm:inline opacity-50">|</span>
              <Link to="/terms" className="text-sm opacity-70 hover:opacity-100 transition-opacity" data-testid="terms-link">{t('footer.termsOfService')}</Link>
              <span className="hidden sm:inline opacity-50">|</span>
              <Link to="/cookies" className="text-sm opacity-70 hover:opacity-100 transition-opacity" data-testid="cookies-link">{t('footer.cookiePolicy')}</Link>
            </div>
            <p className="text-sm opacity-60">{t('footer.copyright')}<br />{t('footer.allRights')}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};
